import React from "react";
import { Navigate } from "react-router-dom";

import App from "../App.js";
import RequireAuth from "../RequireAuth.jsx";

import UserIndex from "../user/Index.jsx";
import UserList from "../user/UserList.jsx";
import UserDetail from "../user/UserDetail.jsx";

import Register from "../register.jsx";
import Login from "../login.jsx";
import ChangePassword from "../ChangePassword.jsx";
import ImportPage from "../ImportPage.jsx";

import HostIndex from "../hostmanage/Index.jsx";
import Receivable from "../hostmanage/Receivable.jsx";
import Payable from "../hostmanage/Payable.jsx";
import IdleHouse from "../hostmanage/IdleHouse.jsx";
import HostList from "../hostmanage/HostList.jsx";
import HostDetail from "../hostmanage/HostDetail.jsx";
import WaterElectricityMeterRecord from "../hostmanage/WaterElectricityMeterRecord.jsx";
import AssetList from "../hostmanage/AssetListPage.jsx";
import AssetTransactionList from "../hostmanage/AssetTransactionList.jsx";
import RentCollectionPage from "../hostmanage/RentCollectionPage.jsx";
import DictManage from "../hostmanage/DictManagePage.jsx";
import PurchaseRecord from "../hostmanage/PurchaseRecordPage.jsx";
import AssetCategory from "../hostmanage/AssetCategoryPage.jsx";
import ExpenseList from "../hostmanage/ExpenseList.jsx";

const indexRouter = {
  path: "/",
  children: [
    {
      index: true,
      element: <App />,
    },

    {
      path: "login",
      element: <Login />,
    },

    {
      path: "register",
      element: <Register />,
    },

    {
      element: <RequireAuth />,
      children: [
        {
          path: "user",
          element: <UserIndex />,
          children: [
            {
              index: true,
              element: <Navigate to="list" />,
            },
            {
              path: ":id",
              element: <UserDetail />,
            },
            {
              path: "list",
              element: <UserList />,
            },
          ],
        },

        {
          path: "logout",
          element: <div>UserLogout</div>,
        },

        {
          path: "change-password",
          element: <ChangePassword />,
        },
      ],
    },

    {
      element: <RequireAuth />,
      children: [
        {
          path: "import",
          element: <ImportPage />,
        },

        {
          path: "host",
          element: <HostIndex />,
          children: [
            {
              index: true,
              element: <Navigate to="list" />,
            },

            {
              path: "receivable",
              element: <Receivable />,
            },

            {
              path: "WaterElectricityMeterRecord",
              element: <WaterElectricityMeterRecord />,
            },

            {
              path: "dictManage",
              element: <DictManage />,
            },

            {
              path: "assetCategory",
              element: <AssetCategory />,
            },

            {
              path: "purchaseRecord",
              element: <PurchaseRecord />,
            },

            {
              path: "asset",
              element: <AssetList />,
            },

            {
              path: "assetTransaction",
              element: <AssetTransactionList />,
            },

            {
              path: "payable",
              element: <Payable />,
            },

            {
              path: "rentCollection",
              element: <RentCollectionPage />,
            },

            {
              path: "expense",
              element: <ExpenseList />,
            },

            {
              path: "idlehouse",
              element: <IdleHouse />,
            },

            {
              path: "list",
              element: <HostList />,
            },

            {
              path: ":id",
              element: <HostDetail />,
            },
          ],
        },
      ],
    },
  ],
};

export default indexRouter;
